const taskStates = [
  { id: 'open', title: 'Open' },
  { id: 'done', title: 'Done' },
];

export default taskStates;
